export default __webpack_public_path__ + "static/media/watermill.dc648181.svg";